export const depositsTransactions = {
  // usage: accepts fixed values like rem, px or %; fr means "free space" - takes all space left after fixed values and distributes it in proportion to Nfr
  // hidden columns drop out of the grid, so do not have to be declared in grid-cols-xxx
  columnParams: 'grid-cols-[50%,20%,1fr,1fr] sm:grid-cols-[30%,30%,15%,2fr,1fr] lg:grid-cols-[6rem,1fr,2fr,6rem,5rem,2rem]',
  columns: [
    [
      { id: 'date', type: 'date', textAlign: 'text-left' },
      { id: 'otherParty', type: 'string', textAlign: 'text-left', classNamesBoth: 'lg:hidden' },
      { id: 'otherPartyAccount', type: 'string', textAlign: 'text-left', classNamesBoth: 'lg:hidden', classNamesBody: 'text-xs truncate', classNamesHeader: 'hidden' },
      { id: 'description', type: 'string', textAlign: 'text-left', classNamesBody: 'truncate', classNamesBoth: 'sm:hidden' },
    ],
    [
      { id: 'otherParty', type: 'string', textAlign: 'text-left', classNamesBoth: 'hidden lg:block' },
      {
        id: 'otherPartyAccount',
        type: 'string',
        textAlign: 'text-left',
        classNamesBoth: 'hidden lg:block',
        classNamesBody: 'text-xs text-gray-400 rtl truncate',
        classNamesHeader: 'hidden',
      },
    ],
    [
      {
        id: 'description',
        type: 'string',
        textAlign: 'text-left',
        classNamesBoth: 'hidden sm:block',
      },
    ],
    [
      {
        id: 'accountCurrencyAmount',
        type: 'currency',
        usesHeader: 'amount',
        textAlign: 'text-right',
      },
      {
        id: 'fxAmount',
        type: 'fxCurrency',
        classNamesBody: 'text-xs text-gray-400',
        // formatting function takes transaction.currency and transaction.fxCurrency as arguments;
        // the fxCurrency types use fxCurrency instead of currency
      },
    ],
    [
      {
        id: 'label',
        type: 'label',
        // textAlign: 'justify-self-center',
        classNamesBody: 'justify-self-center min-w-0',
        usesHeader: 'type',
      },
    ],
    [
      {
        id: 'ellipsis',
        type: 'ellipsis',
        // usesHeader: 'emptyString',
        classNamesBody: 'justify-self-center',
        usesHeader: null,
        // classNamesBody: '-ml-3',
      },
    ],
  ],
};

export default true;
